import { WorkflowType } from './enums/workflow-type';
import { Task } from './task';

export interface PhobosTaskInstancePmsDataItem {
   id: number;
   data: string | unknown;
   riskFactors?: string;
   taskInstanceId?: number;
   createdBy?: number;
   createdDate?: string;
   status?: string | null;
}
export class PhobosTaskInstance {
   id: number = 0;
   propertyId: number = 0;
   taskId: number = 0;
   documentId: string = '';
   createdDate: string = '';
   completedDate: string = '';
   createdBy: number = 0;
   name: string = '';
   description: string = '';
   pmsReportTypeId?: number;
   pmsReportTypeName?: string;
   isAssignedToUser: boolean = false;
   type: WorkflowType = WorkflowType.Daily;
   pmsData: PhobosTaskInstancePmsDataItem[] = [];

   constructor() {}

   public toV1Task(): Task {
      const result = new Task();
      result.processId = this.id;
      result.type = this.type;
      result.name = this.name;
      result.description = this.description;
      result.isAssignedToUser = this.isAssignedToUser;
      result.dueDate = this.createdDate;

      return result;
   }
}
